import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AppProvider from "context/providers/AppProvider";
import { configuration } from "authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ToastProvider } from "context/toast-context/ToastProvider";
import { LoaderProvider } from "components/loader/GlobalLoader";

const container = document.getElementById("root");
const root = createRoot(container);

const msalInstance = new PublicClientApplication(configuration);

root.render(
  <MsalProvider instance={msalInstance}>
    <ToastProvider>
      <LoaderProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </LoaderProvider>
    </ToastProvider>
  </MsalProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
